import { Injectable } from '@angular/core';
import { API_ENDPOINT, ApiUtils } from '../utils/api/api-utils';
import { InviteReturnTypes, LinkData, LinkReturnTypes, ProductData, ProductOfferData } from '../utils/commonTypes';
import { ApiResultTypes } from '../utils/domain-services-api-reason-codes';

@Injectable({
  providedIn: 'root'
})
export class InviteService {


  //----------------------------
  //---GET LINK (unauthorized) ---
  //----------------------------

  public async getLink(linkId: string): Promise<
    { link: LinkData, result: ApiResultTypes }
  > {
    const apiEndpoint = `${API_ENDPOINT}/link/${linkId}`;
    const response = await ApiUtils.apiCall<
      { link: LinkData, result: ApiResultTypes }
    >('get', apiEndpoint,);
    return response;
  }


  //----------------------------
  //---CREATE INVITE ---
  //----------------------------


  public async createInvite(groupId: string): Promise<
    { linkId?: string, result: ApiResultTypes }
  > {
    const apiEndpoint = `${API_ENDPOINT}/invite/${groupId}`;
    const response = await ApiUtils.apiCall<
      { linkId?: string, result: ApiResultTypes }
    >('post', apiEndpoint);
    return response;
  }

  //----------------------------
  //---LOAD INVITE ---
  //----------------------------


  public async getLinkFull(linkId: string): Promise<
    {
      link: LinkData
      productOffer: ProductOfferData
      groupMember?: boolean
      nextStep: string
      paymentLink?: string,
      result: ApiResultTypes
    }
  > {

    const apiEndpoint = `${API_ENDPOINT}/link-internal/${linkId}`;
    const response = await ApiUtils.apiCall<
      {
        link: LinkData
        productOffer: ProductOfferData
        groupMember?: boolean
        nextStep: string
        paymentLink?: string,
        result: ApiResultTypes
      }
    >(
      'get',
      apiEndpoint,
    );
    return response;
  }

  public async getOfferById(offerId: string): Promise<
    {
      offer: ProductOfferData
      result: ApiResultTypes,
      product: ProductData
    }
  > {

    const apiEndpoint = `${API_ENDPOINT}/store/offer/${offerId}`;
    const response = await ApiUtils.apiCall<
      {
        offer: ProductOfferData
        result: ApiResultTypes,
        product: ProductData
      }
    >(
      'get',
      apiEndpoint,
    );
    return response;
  }


  public async createPaymentTransaction(offerId: string, paymentReturnUrl: string): Promise<{paymentLink: string}> {

    const apiEndpoint = `${API_ENDPOINT}/store/transaction/${offerId}`;
    const response = await ApiUtils.apiCall<{paymentLink: string}>(
      'post',apiEndpoint,
      {
        paymentReturnUrl: paymentReturnUrl
      }
    );
    return response;
  }

  public async createPaymentProfile(offerId: string, taxNumber: string): Promise<boolean> {

    const apiEndpoint = `${API_ENDPOINT}/store/profile/`;
    const response = await ApiUtils.apiCall<
      {
        result: ApiResultTypes
      }
    >(
      'post',
      apiEndpoint,
      {
        offerId: offerId,
        taxNumber: taxNumber
      }
    );
    return response.result === ApiResultTypes.SUCCESS;
  }

  public async confirmFakeTransaction(offerId: string): Promise<
    {
      result: string
    }
  > {

    const apiEndpoint = `${API_ENDPOINT}/store/confirmfaketransaction/${offerId}`;
    const response = await ApiUtils.apiCall<
      {
        result: ApiResultTypes
      }
    >(
      'post',
      apiEndpoint,
    );
    return response;
  }


  //----------------------------
  //---ACCEPT INVITE ---
  //----------------------------


  public async acceptInvite(linkId: string): Promise<{ result: ApiResultTypes, reason: InviteReturnTypes }> {
    const apiEndpoint = `${API_ENDPOINT}/invite/accept/${linkId}`;
    const response = await ApiUtils.apiCall<{ result: ApiResultTypes, reason: InviteReturnTypes }>(
      'post',
      apiEndpoint,
    );
    return response;
  }
}

